import { useState } from 'react';
import { removeDangerousSpecialCharacters } from 'modules/utils/removeDangerousSpecialCharacters';

function useContactUsEmail() {
  const [emailAddress, setEmailAddress] = useState<string>();
  const [emailError, setEmailError] = useState<boolean>(false);
  const handleEmailAdd = (event: React.ChangeEvent<HTMLInputElement> | undefined) => {
    if (event) {
      const emailWithDangerousCharactersRemoved = removeDangerousSpecialCharacters(
        event.target.value
      );
      setEmailAddress(emailWithDangerousCharactersRemoved);
      setEmailError(false);
    }
  };
  return {
    emailAddress,
    emailError,
    onEmailAdd: handleEmailAdd,
    onEmailError: setEmailError,
  };
}

export default useContactUsEmail;
